export default "__VITE_ASSET__BIOZNGYA__"